
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/create",
      function () {
        return require("private-next-pages/events/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/create"])
      });
    }
  